<!--
 * @Author: lan.h
 * @Date: 2022-02-22 10:16:22
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-28 11:09:33
 * @Description: 专栏作者
-->
<template>
  <div class="author" v-if="author.length > 0">
    <div class="mode-title">
      <span class="title-p">专栏作者</span>
      <a  class="more" :href="$store.state.index2_path + '/User/authorList'" target="_blank"
          onclick="_czc.push(['_trackEvent', '首页(新)', '右侧专栏作者(查看更多)', '点击量'])">查看更多</a>
    </div>
    <ul class="author-content">
      <li v-for="item, index in author" :key="index" @click="toAuthor(item)">
        <img class="logo" :src="item.logo_path | logo_show('', $store.state.static_img_url+'pic/default_header.png')">
        <div class="right">
          <p class="name">{{item.name}}<img :src="$store.state.static_img_url+'pic/vcbeat/r.png'"></p>
          <p class="desc over-p1">{{item.description}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { hotauthor } from "../../service";
export default {
  data() {
    return {
      author: [],
      loading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    toAuthor(a) {
      const href = this.$store.state.index2_path + '/Article/authorArticle/keyword/' + a.base64Id
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '首页(新)', '右侧专栏作者(作者)', '点击量'])
    },
    async getList() {
      this.loading = true
      let res = await hotauthor( {}, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'author', res.data ? res.data.slice(0, 4) : [])
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.author
  &-content
    display flex 
    flex-flow wrap
    li 
      margin-top 20px
      display flex
      align-items center
      width 100%
      cursor pointer
      .logo
        width 60px
        height 60px
        border-radius 50%
        margin-right 20px
      .right
        width calc(100% - 80px)
        .name
          font-size 20px
          font-weight 500
          color #333333
          line-height 1
          display flex 
          align-items center
          img 
            margin-left 5px
        .desc
          font-size 14px
          font-weight 500
          color #999999
          line-height 1
          margin-top 9px
  .more
    font-size 14px
    font-weight 500
    &:hover 
      color #FF4800
</style>